import { AsyncPipe, NgClass, NgStyle } from '@angular/common';
import { Component, inject } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations'
import { IconComponent } from '@kinomap-dev/ng-ui-lib';
import { Toast, ToasterService } from 'app/services/toaster.service';

@Component({
  selector: 'app-toaster',
  standalone: true,
  imports: [NgClass, NgStyle, AsyncPipe, IconComponent],
  template: `
  <div class="toast-container">
    @for(toast of (toasterService.toasts$| async); track $index){
      <div class="toast" [ngStyle]="{'--duration': toast.duration + 'ms'}"  [ngClass]="toast.type" [@toastAnimation]>
        <header>
          <p class="title">{{getTitle(toast)}}</p>
          <kin-icon [color]="'#e2e2e2'" name="close" [size]="16" (iconClick)="toasterService.remove(toast.id)" />
        </header>
        <p class="message">{{toast.msg}}</p>
        <div class="toast-loader"></div>
      </div>
    }
  </div>
`,
  styleUrl: './toaster.component.scss',
  animations: [
    trigger('toastAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('300ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateY(100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class ToasterComponent {
  public toasterService: ToasterService = inject(ToasterService);

  getTitle(toast: Toast): string {
    switch (toast.type) {
      case 'success':
        return toast.title = toast.title ? toast.title : 'Success';
      case 'error':
        return toast.title = toast.title ? toast.title : 'Error';
      case 'info':
        return toast.title = toast.title ? toast.title : 'Info';
      case 'warning':
        return toast.title = toast.title ? toast.title : 'Warning';
      default:
        return toast.title = '';
    }
  }
}
